import React from 'react';
import { Route, Switch, Redirect } from 'react-router';
import { makeURL } from '../../../helperFunctions';
import BrandPersonaReport from './BrandPersonaReport';
import BuyerPersonaReport from './BuyerPersonaReport';
import ConsumerReport from './ConsumerReport';
import MarketingStrategyReport from './MarketingStrategyReport';

const ReportExportRoutes = () => (
  <Switch>
    <Route path={makeURL('/report-export/brand-persona/:id')} exact component={BrandPersonaReport} />
    <Route path={makeURL('/report-export/buyer-persona/:id')} exact component={BuyerPersonaReport} />
    <Route path={makeURL('/report-export/consumer-dashboard')} exact component={ConsumerReport} />
    <Route path={makeURL('/report-export/marketing-strategy/:id')} exact component={MarketingStrategyReport} />
    <Redirect to={makeURL('/report-export/consumer-dashboard')} />
  </Switch>
);

export default ReportExportRoutes;
